// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"810":"6f25e624","879":"b7c1ba51","943":"7078bf06"}[chunkId] + ".js";
};